/**
 * Каталог окон. Размер — параметр, а не тип: типы различаются числом створок и тем,
 * стоит окно на подоконнике или стеклопакет идёт до пола (панорамное, балконная дверь).
 */
import { LayerKind } from "@/shared/plan/layerKind";
import type { CatalogSection } from "../../types";
import type { WindowCatalogItem } from "./types";

export const windowSection: CatalogSection<WindowCatalogItem> = {
	kind: LayerKind.Walls,
	label: "Окна",
	canChangeDimensions: false,
	subGroups: ["Окна", "Балконные"],
	items: [
		{
			id: "window-1400",
			subGroup: "Окна",
			name: "Двустворчатое",
			description: "Окно из двух створок на подоконнике. Размер задаётся при установке.",
			color: "#7fa8c4",
			width: 1400,
			height: 1400,
			sill: 850,
			sashes: 2,
		},
		{
			id: "window-single",
			subGroup: "Окна",
			name: "Одностворчатое",
			description: "Узкое окно из одной створки: ванная, кухня, лестница.",
			color: "#7fa8c4",
			width: 700,
			height: 1400,
			sill: 850,
			sashes: 1,
		},
		{
			id: "window-triple",
			subGroup: "Окна",
			name: "Трёхстворчатое",
			description: "Широкое окно из трёх створок на подоконнике.",
			color: "#7fa8c4",
			width: 2100,
			height: 1400,
			sill: 850,
			sashes: 3,
		},
		{
			id: "window-panoramic",
			subGroup: "Окна",
			name: "Панорамное",
			description: "Стеклопакет почти от пола до потолка, без подоконника.",
			color: "#7fa8c4",
			width: 2400,
			height: 2300,
			sill: 100,
			sashes: 3,
		},
		{
			id: "window-balcony",
			subGroup: "Балконные",
			name: "Балконная дверь",
			description: "Стеклопакет в пол - выход на балкон.",
			color: "#7fa8c4",
			width: 800,
			height: 2100,
			sill: 0,
			sashes: 1,
		},
	],
};
